import { StripeChargeT, StripePaymentMethodT, SubscriptionDataT } from "../records/IUserSubscriptionStatusRecord";

export enum SubscriptionPaymentStatusT {
  PRE_PAYMENT = 0,
  PENDING_PAYMENT = 2,
  PAYMENT_VALID = 3,
  PAYMENT_FAILED = 4,
  PAYMENT_ENDED = 5,
  PAYMENT_PROCESSING = 7,
}

export enum SubscriptionPlanTypeT {
  TEAMS = 0,
  FAMILY = 1,
}

export interface SubscriptionPaymentStatusObjectT {
  isActive: boolean;
  isCanceled: boolean;
  isTrialing: boolean;
  expiration: number;
  status: SubscriptionPaymentStatusT;
  paymentMethodInfo?: StripePaymentMethodT; // only provided to space admins
  invoiceUrl?: string; // only provided to space admins
  trialExtendEligibilityDate?: number | null;
}

/* Plans - Teams */
export enum TeamsPlanPeriod {
  YEAR = "Year",
  MONTH = "Month",
}

export enum TeamsPlanPaymentProvider {
  STRIPE = "Stripe",
  WHITELIST = "Whitelist",

  MAC_APP_STORE = "OSx",
  IOS_APP_STORE = "iOS",
  GOOGLE_PLAY_MARKET = "Play",
}

export interface IWorkspaceSubscriptionPlan {
  id: string;
  paymentProvider: TeamsPlanPaymentProvider;
  subscriptionData: SubscriptionDataT | {};
  activePlan: string;
  planPeriod: TeamsPlanPeriod;
  trialPeriod: number; // number of days
  serverExpirationDate: number;
  serverLastUpdateDate: number;
  serverSubscriptionDate: number;
  orderId: string;
  isCanceled: boolean;
  isFree: boolean;
  isTrialing: boolean;
  billingEmail: string;
  fromCampaign: string | null;
  customerId: string;
  paymentStatus: SubscriptionPaymentStatusT;
  paymentStatusLastUpdate: number;
  paymentMethodInfo: StripePaymentMethodT | null;
  paymentFailureInfo: StripeChargeT | null;
  billedSeats: number | null;
  planType: SubscriptionPlanTypeT;
  invoiceUrl?: string;
  countryCode: string | null;
}

export type SpaceSubscriptionT = {
  paymentProvider: TeamsPlanPaymentProvider.MAC_APP_STORE;
  planType: SubscriptionPlanTypeT;
  activePlan: string;
  planPeriod: "Month" | "6_Month" | "Year";
  orderId: string;
  subscriptionData: {
    transactionId: string;
    environment: "sandbox" | "production";
  };
};
